import { ActionContext } from "vuex";
import jwt_decode from "jwt-decode";

import { GSIResponse, GSIDecodedToken, UserProfile } from "@/types";
import { RootState } from "@/stores";
import { AuthState } from "./index";

export async function updateAuthInfo(
  { commit }: ActionContext<AuthState, RootState>,
  googleResponse: GSIResponse
) {
  if (!googleResponse) return;
  const decodedToken = jwt_decode(googleResponse.credential) as GSIDecodedToken;

  const user: UserProfile = {
    id: decodedToken.sub,
    email: decodedToken.email,
    familyName: decodedToken.family_name,
    givenName: decodedToken.given_name,
    name: decodedToken.name,
    imageUrl: decodedToken.picture,
  };

  // GSI reponse is different, try to mimic GAPI response here (interface GoogleAuthResponse)
  const auth = {
    access_token: googleResponse.credential,
    expires_at: decodedToken.exp * 1000, // equivalent with the previous getAuthResponse()
    expires_in: decodedToken.nbf * 1000,
    first_issued_at: decodedToken.iat * 1000, // equivalent with the previous getAuthResponse()
    id_token: googleResponse.credential, // equivalent with the previous getAuthResponse()
    idpId: "google", // hardcoded value by looking at the previous getAuthResponse()
    scope: "",
    token_type: "bearer", // hardcoded value by looking at the previous getAuthResponse()
    login_hint: "",
  };

  commit("setAuth", auth);
  commit("setUser", user);
}

export async function resetAuthInfo({
  commit,
}: ActionContext<AuthState, RootState>) {
  commit("setAuth", null);
  commit("setUser", null);
}
